"use client";
import { useHeaderTheme } from "@onclicks/sharedcomponents/HeaderTheme";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";

import type { IconSvg } from "@/types/IconSvg";
import { Header, type HeaderData } from "./Header";

export const HeaderClient: React.FC<
  HeaderData & { icons: Record<string, IconSvg> }
> = ({ icons, ...data }) => {
  /* Storing the value in a useState to avoid hydration errors */
  const [theme, setTheme] = useState<string | null>(null);
  const { headerTheme, setHeaderTheme } = useHeaderTheme();
  const pathname = usePathname();

  useEffect(() => {
    setHeaderTheme(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (headerTheme && headerTheme !== theme) setTheme(headerTheme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTheme]);

  return (
    <header className="relative z-[999]">
      <Header data={data} icons={icons} />
    </header>
  );
};
